import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { BillMatrixPage } from '../pages/BillMatrixPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/payment-grid')({
  component: PaymentGrid,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function PaymentGrid() {
  return (
    <MainLayout>
      <BillMatrixPage />
    </MainLayout>
  )
}
